import React from 'react';
import { version } from 'react';
import LinkService from "../../services/LinkService";
export default function Home() {
    let linkService = new LinkService()
return (
  <div className="container">
    <div className="row d-flex justify-content-center">
      <div className="col-sm-10 text-center">
        <br /><br />
        


        
        <h4>Guitar Theory Workout for iOS - Try the Always Free Edition.</h4>
        <div className="ratio ratio-16x9 mb-4">
          <iframe
            src="https://www.youtube.com/embed/fBx52tG0duA"
            title="Guitar Theory Workout App for iOS"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
        </div>

        {/* First video title */}
        <h4>Guitar Theory Workout for Android - Try the Always Free Edition.</h4>
        <div className="ratio ratio-16x9 mb-4">
          <iframe
            src="https://www.youtube.com/embed/iD6xKUDsgIM"
            title="Guitar Theory Workout App for Android"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
        </div>

        {/* Second video title */}
        <h4>Tim Pierce Explains Why Knowing Triads is Essential for Any Guitarist</h4>
        <div className="ratio ratio-16x9 mb-4">
          <iframe
            src="https://www.youtube.com/embed/1e3kSkCTiUA"
            title="Why PROS Use TRIADS - Beginners Use SCALES - Tim Pierce - Live Stream"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
        </div>

        <br /><br />
      </div>
    </div>
  </div>
);

}
